import React, { CSSProperties, useMemo } from 'react';
import { Empty } from 'antd';

interface IProps {
	message?: string,
	containerClassName?: string,
	containerStyle?: CSSProperties,
	/** classname of the container content */
	className?: string,
	/** style of the container content */
	style?: CSSProperties
}

const NoDataMessageContainer = (props: IProps) => {
	const classNames: { containerClassName: string, contentClassName: string } = useMemo(() => {
		let containerClassName = 'pos-rel';
		if (props.containerClassName) containerClassName += ' ' + props.containerClassName;

		let contentClassName = 'pos-abs-center';
		if (props.className) contentClassName += ' ' + props.className;

		return { containerClassName, contentClassName };
	}, [props]);

	return (
		<div
			className={classNames.containerClassName}
			style={props.containerStyle}
		>
			<Empty
				image={Empty.PRESENTED_IMAGE_SIMPLE}
				description={props.message}
				className={classNames.contentClassName}
				style={{ margin: 0 }}
			/>
		</div>
	);
};

export default NoDataMessageContainer;